<template>
  <div>
    <header class="bar bar-nav">
      <h1 class="title">设置发票信息</h1>
      <router-link :to="{name : 'orderContentConfirm'}" class="button button-link button-nav pull-left">
        <span class="icon icon-left" style="font-size: 18px">返回</span>
      </router-link>
    </header>
    <div class="content">
      <div class="checkout-title">
        <span>发票类型</span>
      </div>
      <div class="list-block media-list" style="margin-top: 1px;margin-bottom:2px;">
        <ul>
          <li>
            <div class="item-inner" style="left: 10px;">
              <div class="row">
                <div class="item-title button col-50">增值税发票(普通)</div>
                <div class="item-title-after button col-50">增值税发票</div>
              </div>
              <!--<div class="item-subtitle">纸质发票</div>-->
              <!--<div class="item-text">此处是文本内容...</div>-->
            </div>
          </li>
        </ul>
      </div>
      <div class="checkout-title">
        <span>发票抬头</span>
      </div>
      <div class="list-block" style="margin-top: 2px;margin-bottom:2px;">
        <ul>
          <li>
          <li>
            <div class="item-content">
              <!--<div class="item-media"><i class="icon icon-form-name"></i></div>-->
              <div class="item-inner">
                <div class="item-input">
                  <input type="text" placeholder="请填写单位名称">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <!--<div class="item-media"><i class="icon icon-form-email"></i></div>-->
              <div class="item-inner">
                <div class="item-input">
                  <input type="phoneNumber" placeholder="请填写纳税人识别号">
                </div>
              </div>
            </div>
          </li>
          <li>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// InvoiceDetail.vue?3c1d510d